<template>
  <div class="plan-container my-5 w-100 d-flex align-items-center justify-content-center">
    <div v-if="plan" class="list-container p-2">
      <ul>
        <li v-for="(s, idx) in plan.specs" :key="idx">
          <Icon color="#3f80f1" icon="tick" />
          {{ s.spec }}
          <b-button v-if="s.tooltip" v-b-tooltip.hover class="list-tooltip" :title="s.tooltip">
            i
          </b-button>
        </li>
      </ul>
      <img
        v-if="plan.image"
        :src="plan.image"
        loading="lazy"
        :alt="$t('plans.common.cards.PODlogosAlt')"
        class="mt-2"
      />
    </div>
    <div v-if="plan" class="price-container d-flex align-items-end p-2 mt-auto">
      <div class="w-100">
        <p v-if="plan">
          {{ $t('purchase.plans.common.subTotal') }}: {{ plan.currencyCode }} {{ plan.cost }}<br />
          <span class="font-weight-bold"
            >{{ $t('purchase.plans.common.totalPrice') }}: {{ plan.currencyCode }}
            {{ plan.cost }}
          </span>
        </p>
        <Button
          shape="full"
          color="green"
          width="full"
          :enabled="buttonEnabled"
          text="white"
          @click="openModalPurchase()"
          >{{ buttonText }}</Button
        >
      </div>
    </div>

    <Loading v-show="!plan" />
  </div>
</template>

<script>
import Button from 'UI/Button';
import Icon from 'UI/Icon';
import Loading from 'UI/Loading';

export default {
  name: 'PlanContainer',
  components: {
    Button,
    Icon,
    Loading
  },
  props: {
    plan: {
      type: Object,
      required: true
    }
  },
  computed: {
    buttonEnabled() {
      return this.plan.upgrade;
    },
    buttonText() {
      if (this.$auth.loggedIn && !this.isFreeUser && this.plan.upgrade) {
        return this.$t('plans.common.cards.upgrade');
      } else {
        return this.$t('purchase.plans.common.suscribe');
      }
    }
  },
  mounted() {
    this.$store.commit('plans/SET_STEP_ACTION', 'closeModal');
  },
  destroyed() {
    this.$store.commit('plans/SET_STEP_ACTION', '');
  },
  methods: {
    openModalPurchase() {
      this.$store.dispatch('plans/OPEN_PLAN', this.plan);
      this.$cookies.set('vx.plan', this.plan);
      this.$bvModal.show('purchase-modal');
    }
  }
};
</script>

<style lang="scss" scoped>
.plan-container {
  background-color: #ffffff;
  border: 1px solid #f1f1f1;
  border-radius: 8px;
  box-shadow: 0px 0px 15px 0px rgb(230, 230, 230);
  padding: 50px 100px;
  flex-wrap: wrap;
  min-height: 350px;
  @include lg {
    padding: 50px 70px;
  }
  @include md {
    padding: 50px;
  }
  @include sm {
    padding: 50px 15px;
  }
  .list-container {
    width: 75%;
    @include xl {
      width: 60%;
    }
    @include lg {
      width: 50%;
    }
    @include md {
      width: 100%;
    }
    ul {
      list-style: none;
      padding: 0;
      > li {
        font-size: 15px;
        line-height: 32px;
        color: #747474;
        > .list-tooltip {
          background-color: #3cd699;
          border: none;
          height: 20px;
          width: 20px;
          border-radius: 200%;
          padding: 0;
          font-weight: 500;
        }
      }
    }
    img {
      width: 270px;
      @include xs {
        width: 100%;
      }
    }
  }
  .price-container {
    width: 25%;
    @include xl {
      width: 40%;
    }
    @include lg {
      width: 50%;
    }
    @include md {
      width: 100%;
    }
    p {
      font-size: 15px;
      line-height: 32px;
      color: #747474;
      margin: 0;
    }
  }
  .icon-tick {
    position: relative;
    top: 3px;
  }
}
</style>
